var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.75C6.63672 0.75 6.34375 1.04297 6.34375 1.40625V1.83984C4.47656 2.14453 3.0625 3.76562 3.0625 5.71875V6.29297C3.0625 7.47656 2.62891 8.62109 1.84766 9.50781L1.66016 9.71875C1.44922 9.95703 1.39844 10.2969 1.52734 10.5859C1.65625 10.875 1.94531 11.0625 2.26562 11.0625H11.7344C12.0547 11.0625 12.3438 10.875 12.4727 10.5859C12.6016 10.2969 12.5508 9.95703 12.3398 9.71875L12.1523 9.50781C11.3711 8.62109 10.9375 7.47656 10.9375 6.29297V5.71875C10.9375 3.76562 9.52344 2.14453 7.65625 1.83984V1.40625C7.65625 1.04297 7.36328 0.75 7 0.75ZM7 3.0625C8.46875 3.0625 9.625 4.21875 9.625 5.71875V6.29297C9.625 7.42578 9.96094 8.53125 10.582 9.46875H3.41797C4.03906 8.53125 4.375 7.42578 4.375 6.29297V5.71875C4.375 4.21875 5.53125 3.0625 7 3.0625ZM8.53516 12.375H5.46484C5.46484 12.7852 5.62891 13.1758 5.91797 13.4648C6.20703 13.7539 6.59766 13.9375 7 13.9375C7.40234 13.9375 7.79297 13.7539 8.08203 13.4648C8.37109 13.1758 8.53516 12.7852 8.53516 12.375Z",
    fill: "#3A8FD8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.ba1e342187b900b4ed6fc2a9d8771618.svg";
export { ForwardRef as ReactComponent };